import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { SeoTags } from "../../components";
import { ServicesComponent } from "../../components/info/ServicesComponent";
import { setShowSearch } from "../../store/appConfigsSlice";

const ServicesPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, [dispatch]);

  return (
    <>
      <SeoTags pageKey="servicesPage" />
      <ServicesComponent />
    </>
  );
};

export default withTranslation()(ServicesPage);
